  const NotFound = () =>{
    return (
        <div className="window-wrapper">
            <div className="content-wrapper">
                <h2>見つかりません</h2>
                恐れ入りますが、お探しのページは見つかりませんでした。
            </div>
        </div>
    );
}

export default NotFound;